export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 70;

export const PASSWORD_REQUIREMENTS_TEXT = `Must be between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters`;
